// extracted by mini-css-extract-plugin
export default {"edit-object":"editObject_edit-object__mTVCV","row":"editObject_row__1-hAl","actions":"editObject_actions__yZxL8"};